import * as Styled from "./BraintreeField.styles";

import { FormHelperText } from "@mui/material";

interface BraintreeFieldProps {
  error: boolean;
  errorText: string;
  id: string;
  label: string;
  hideLabel?: boolean;
  handleErrorsOnParent?: boolean;
}

function BraintreeField({
  error,
  errorText,
  id,
  label,
  hideLabel,
  handleErrorsOnParent,
}: BraintreeFieldProps): React.ReactElement {
  return (
    <Styled.FormControl error={error}>
      <Styled.Label data-testid={id} hidden={hideLabel}>
        {label}
      </Styled.Label>
      <div
        id={id}
        className={error ? "braintree-hosted-fields-invalid" : ""}
        data-testid={`test-${id}`}
      ></div>
      {error && errorText && !handleErrorsOnParent && (
        <FormHelperText className="error-text">{errorText}</FormHelperText>
      )}
    </Styled.FormControl>
  );
}

export default BraintreeField;
